(()=>{
  const q=(root,sel)=>root.querySelector(sel);
  const qa=(root,sel)=>[...root.querySelectorAll(sel)];
  const money=(cents)=>{
    try{
      if(window.Shopify && typeof window.Shopify.formatMoney==='function'){
        return window.Shopify.formatMoney(Number(cents)||0,window.theme?.moneyFormat||window.Shopify.money_format||'${{amount}}');
      }
    }catch(_){}
    return '$'+((Number(cents)||0)/100).toFixed(2);
  };

  function showToast(root,title,text){
    const toast=q(root,'[data-m42-toast]');
    if(!toast)return;
    const titleEl=q(toast,'[data-m42-toast-title]');
    const textEl=q(toast,'[data-m42-toast-text]');
    if(titleEl)titleEl.textContent=title;
    if(textEl)textEl.textContent=text;
    toast.classList.add('show');
    clearTimeout(toast._pf35Timer);
    toast._pf35Timer=setTimeout(()=>toast.classList.remove('show'),2600);
  }

  function fireCartEvent(name,detail){
    try{document.dispatchEvent(new CustomEvent(name,{detail,bubbles:true}));}catch(_){}
    try{document.body?.dispatchEvent(new CustomEvent(name,{detail,bubbles:true}));}catch(_){}
  }

  function getThemeCartComponent(){
    return document.querySelector('cart-drawer')||document.querySelector('cart-notification')||null;
  }

  function getThemeCartSectionIds(component){
    if(!component||typeof component.getSectionsToRender!=='function')return[];
    try{
      return [...new Set((component.getSectionsToRender()||[]).map(section=>typeof section==='string'?section:(section?.section||section?.id||'')).filter(Boolean))];
    }catch(_){return[];}
  }

  function updateVisibleCartValues(cart){
    if(!cart)return;
    const count=Number(cart.item_count||0),total=Number(cart.total_price||0);
    const countSelectors=['[data-cart-count]','[data-cart-item-count]','.cart-count','.cartCount','.js-cart-count','.site-header__cart-count','.Header__CartCount','.cart-link__bubble-num','.hc-items-count','#CartCount','#cartCount'];
    document.querySelectorAll(countSelectors.join(',')).forEach(element=>{
      const inner=element.matches('#CartCount,#cartCount')?element.querySelector('span'):null;
      const target=inner||element;
      target.textContent=String(count);
      element.hidden=false;
      element.classList.remove('hidden','hidden-count','is-empty');
    });
    const totalSelectors=['[data-cart-total]','[data-cart-subtotal]','#cart-price','.cart-total .money','.cart__subtotal .money','.mini-cart__total .money','.hc-buttons .amount'];
    document.querySelectorAll(totalSelectors.join(',')).forEach(el=>{el.textContent=money(total);});
  }

  async function refreshCartDrawerMarkup(rootPath){
    const response=await fetch(`${rootPath}cart`,{headers:{Accept:'text/html','X-Requested-With':'XMLHttpRequest'},cache:'no-store',credentials:'same-origin'});
    if(!response.ok)return false;
    const html=await response.text();
    const parsed=new DOMParser().parseFromString(html,'text/html');
    const selectors=['#sidebar-cart','#CartDrawer','#cartDrawer','#cart-drawer','#mini-cart','[data-cart-drawer]','.cart-drawer','.mini-cart-popup'];
    let replaced=false;const handled=new Set();
    selectors.forEach(selector=>{
      const current=document.querySelector(selector),incoming=parsed.querySelector(selector);
      if(!current||!incoming||handled.has(current))return;
      current.innerHTML=incoming.innerHTML;handled.add(current);replaced=true;
    });
    return replaced;
  }

  function refreshHCSideCart(cart){
    if(!cart)return false;
    const count=Number(cart.item_count||0);
    document.querySelectorAll('.hc-items-count').forEach(el=>el.textContent=String(count));
    document.querySelectorAll('#CartCount > span').forEach(el=>el.textContent=String(count));
    document.querySelectorAll('.hc-buttons .amount,#cart-price').forEach(el=>el.textContent=money(cart.total_price||0));
    const targets=[...document.querySelectorAll('.hc-append')];
    if(!targets.length)return false;
    document.querySelectorAll('.hc-mini-table').forEach(table=>table.remove());
    targets.forEach(container=>{
      container.replaceChildren();
      const table=document.createElement('table');table.className='hc-mini-table';
      (cart.items||[]).forEach(item=>{
        const row=document.createElement('tr');row.className='item-details';row.dataset.id=String(item.id);
        const imageCell=document.createElement('td');imageCell.className='td-image';
        if(item.image){const image=document.createElement('img');image.src=item.image;image.alt=item.product_title||item.title||'';imageCell.appendChild(image);}
        const detailsCell=document.createElement('td');
        const titlePrice=document.createElement('div');titlePrice.className='mini_cart_title_price';
        const title=document.createElement('div');title.textContent=item.product_title||item.title||'';titlePrice.appendChild(title);
        if(item.variant_title&&item.variant_title!=='Default Title')titlePrice.appendChild(document.createTextNode(` ${item.variant_title} `));
        const price=document.createElement('span');price.className='item-price';price.textContent=money(item.final_price??item.price??0);titlePrice.appendChild(price);detailsCell.appendChild(titlePrice);
        const minus=document.createElement('a');minus.href='';minus.className='minus-quantity';minus.textContent='−';
        const qty=document.createElement('input');qty.type='text';qty.className='quantity-input';qty.value=String(item.quantity||0);
        const plus=document.createElement('a');plus.href='';plus.className='plus-quantity';plus.textContent='+';
        const remove=document.createElement('a');remove.href='';remove.className='hc-remove';remove.textContent='Remove';
        detailsCell.append(minus,qty,plus,remove);row.append(imageCell,detailsCell);table.appendChild(row);
      });
      container.appendChild(table);
    });
    return true;
  }

  function openThemeCart(detail){
    fireCartEvent('cart:open',detail);fireCartEvent('theme:cart:open',detail);fireCartEvent('drawer:open',{...detail,drawer:'cart'});
    const selectors=['[data-action="toggle-mini-cart"]','[data-action="open-cart"]','[data-cart-toggle]','.js-open-cart','.slide_out_cart_trigger','[aria-controls="sidebar-cart"]','[aria-controls="CartDrawer"]','[aria-controls="cart-drawer"]'];
    const opener=selectors.map(s=>document.querySelector(s)).find(el=>{if(!el)return false;if(el.tagName==='BUTTON')return true;const href=el.getAttribute('href')||'';return href===''||href==='#'||href.startsWith('javascript:');});
    try{opener?.click();}catch(_){}
  }

  async function refreshThemeCart(rootPath,cart,addResult,component){
    const addedItem=Array.isArray(addResult?.items)?addResult.items[0]:addResult;
    const detail={cart,item:addedItem,openMiniCart:true,source:'pet-flow-35'};
    let nativeRendered=false;
    if(component&&typeof component.renderContents==='function'&&addResult){
      try{
        component.classList?.remove('is-empty');
        component.querySelector?.('.drawer__inner')?.classList.remove('is-empty');
        component.renderContents(addResult);
        if(typeof component.open==='function')component.open();
        nativeRendered=true;
      }catch(_){}
    }
    updateVisibleCartValues(cart);
    fireCartEvent('cart:refresh',detail);fireCartEvent('cart:updated',detail);fireCartEvent('cart:update',detail);fireCartEvent('theme:cart:added',detail);fireCartEvent('product:added',detail);
    let hcRendered=false;
    if(!nativeRendered)hcRendered=refreshHCSideCart(cart);
    if(window.jQuery){
      try{
        window.jQuery(document).trigger('cart:refresh',[cart]);
        window.jQuery(document.body).trigger('added.ajaxProduct');
        window.jQuery(document.body).trigger('afterCartLoad.ajaxCart',[cart]);
      }catch(_){}
    }
    if(!nativeRendered&&!hcRendered){
      try{
        if(window.ajaxCart&&typeof window.ajaxCart.load==='function')window.ajaxCart.load();
        else if(window.theme?.ajaxCart&&typeof window.theme.ajaxCart.load==='function')window.theme.ajaxCart.load();
        else await refreshCartDrawerMarkup(rootPath);
      }catch(_){try{await refreshCartDrawerMarkup(rootPath);}catch(__){}}
    }
    updateVisibleCartValues(cart);openThemeCart(detail);
  }

  function initHero(root=document){
    const hero=q(root,'[data-m42-hero]');
    if(!hero||hero.dataset.m42Ready==='true')return;
    hero.dataset.m42Ready='true';

    const page=hero.closest('.m42-page')||root;
    const mainImage=q(hero,'[data-m42-main-image]');
    const visual=q(hero,'[data-m42-main-visual]');
    qa(hero,'[data-m42-thumb]').forEach(thumb=>{
      thumb.addEventListener('click',()=>{
        qa(hero,'[data-m42-thumb]').forEach(item=>{const active=item===thumb;item.classList.toggle('active',active);item.setAttribute('aria-pressed',String(active));});
        const url=thumb.dataset.imageUrl;if(!mainImage||!url)return;
        mainImage.style.opacity='.15';
        window.setTimeout(()=>{mainImage.src=url;mainImage.alt=thumb.dataset.imageAlt||mainImage.alt;mainImage.style.opacity='1';},150);
      });
    });

    if(visual&&mainImage&&window.matchMedia('(pointer:fine)').matches){
      visual.addEventListener('pointermove',event=>{const rect=visual.getBoundingClientRect();const x=(event.clientX-rect.left)/rect.width-.5;const y=(event.clientY-rect.top)/rect.height-.5;mainImage.style.transform=`scale(1.06) translate(${x*-14}px,${y*-10}px)`;});
      visual.addEventListener('pointerleave',()=>{mainImage.style.transform='scale(1)';});
    }

    const form=q(hero,'.m42-product-form');
    const variantsScript=q(page,'[data-m42-variants]');
    const optionsScript=q(page,'[data-m42-option-names]');
    if(!form||!variantsScript||!optionsScript)return;

    let variants=[],optionNames=[];
    try{variants=JSON.parse(variantsScript.textContent||'[]');optionNames=JSON.parse(optionsScript.textContent||'[]');}catch(error){console.error('Pet Flow 35 variant data could not be read.',error);return;}
    if(!Array.isArray(variants)||!variants.length){console.error('Pet Flow 35 has no readable variants.');return;}
    const productHandle=hero.dataset.m42ProductHandle||'';
    const productId=hero.dataset.m42ProductId||'';
    console.info('Pet Flow 35 selector source:', {productHandle,productId,optionNames,variantCount:variants.length});

    const normalise=value=>String(value??'').trim();
    const numericMetres=value=>{const match=normalise(value).match(/[\d.]+/);return match?Number(match[0]):0;};
    const sameOption=(left,right)=>normalise(left)===normalise(right);
    const widthIndex=optionNames.findIndex(name=>normalise(name).toLowerCase().includes('width'));
    const lengthIndex=optionNames.findIndex(name=>normalise(name).toLowerCase().includes('length'));

    if(widthIndex<0 || lengthIndex<0){
      console.error('Pet Flow 35 Shopify variants must contain named Width and Length options.', {optionNames});
      const addButton=q(hero,'[data-m42-add]');
      if(addButton){
        addButton.disabled=true;
        addButton.textContent='Product options unavailable';
      }
      return;
    }

    const widthButtons=qa(hero,'[data-m42-width]');
    const lengthSelect=q(hero,'[data-m42-length]');
    const variantInput=q(form,'input[name="id"]');
    const quantityInput=q(form,'input[name="quantity"]');
    const quantityOutput=q(hero,'[data-m42-qty-output]');
    const addButton=q(form,'[data-m42-add]');
    if(!widthButtons.length||!lengthSelect||!variantInput||!quantityInput)return;

    const variantWidthValues=[...new Set(variants.map(v=>normalise(v.options?.[widthIndex])).filter(Boolean))].sort((a,b)=>numericMetres(a)-numericMetres(b));
    widthButtons.forEach(button=>{const currentValue=normalise(button.dataset.optionValue);const currentNumber=numericMetres(currentValue||button.textContent);const exact=variantWidthValues.find(v=>sameOption(v,currentValue));const numericMatch=variantWidthValues.find(v=>numericMetres(v)===currentNumber);const resolved=exact||numericMatch;if(resolved)button.dataset.optionValue=resolved;});
    let activeWidthButton=widthButtons.find(button=>button.classList.contains('active'));
    if(!activeWidthButton||!variantWidthValues.some(v=>sameOption(v,activeWidthButton.dataset.optionValue)))activeWidthButton=widthButtons.find(button=>numericMetres(button.dataset.optionValue)===4)||widthButtons[0];
    widthButtons.forEach(button=>button.classList.toggle('active',button===activeWidthButton));

    let quantity=Math.max(1,Number(quantityInput.value||1));
    let preferredLengthNumber=numericMetres(lengthSelect.value)||1;
    const selectedWidth=()=>normalise(widthButtons.find(button=>button.classList.contains('active'))?.dataset.optionValue);
    const availableLengthValues=widthValue=>[...new Set(
      variants
        .filter(v=>sameOption(v.options?.[widthIndex],widthValue))
        .map(v=>normalise(v.options?.[lengthIndex]))
        .filter(v=>v&&numericMetres(v)>0)
    )].sort((a,b)=>numericMetres(a)-numericMetres(b));

    function rebuildLengthOptions(preferredNumber=preferredLengthNumber){
      const lengths=availableLengthValues(selectedWidth());
      const previous=normalise(lengthSelect.value);
      lengthSelect.innerHTML='';

      if(!lengths.length){
        const option=document.createElement('option');
        option.value='';
        option.textContent='No lengths available for this width';
        lengthSelect.appendChild(option);
        lengthSelect.disabled=true;
        return;
      }

      lengthSelect.disabled=false;
      lengths.forEach(value=>{
        const option=document.createElement('option');
        option.value=value;
        option.textContent=value;
        lengthSelect.appendChild(option);
      });
      const exactPrevious=lengths.find(value=>sameOption(value,previous));
      const preferred=lengths.find(value=>numericMetres(value)===preferredNumber);
      lengthSelect.value=exactPrevious||preferred||lengths[0]||'';
      preferredLengthNumber=numericMetres(lengthSelect.value)||preferredLengthNumber;
    }
    const selectedLength=()=>normalise(lengthSelect.value);
    const findVariant=()=>{const width=selectedWidth(),length=selectedLength();return variants.find(v=>{const options=v.options||[];return sameOption(options[widthIndex],width)&&sameOption(options[lengthIndex],length);})||null;};

    function updateOrder(){
      const variant=findVariant(),width=numericMetres(selectedWidth()),length=numericMetres(selectedLength()),area=width*length,totalArea=area*quantity,totalPrice=variant?Number(variant.price)*quantity:0;
      variantInput.value=variant?.id||'';quantityInput.value=String(quantity);if(quantityOutput)quantityOutput.textContent=String(quantity);
      const pieceSize=q(hero,'[data-m42-piece-size]'),pieceArea=q(hero,'[data-m42-piece-area]'),totalAreaEl=q(hero,'[data-m42-total-area]'),totalPriceEl=q(hero,'[data-m42-total-price]'),buttonPrice=q(hero,'[data-m42-button-price]');
      if(pieceSize)pieceSize.textContent=`${width}m × ${length}m`;if(pieceArea)pieceArea.textContent=`${area}m²`;if(totalAreaEl)totalAreaEl.textContent=`${totalArea}m²`;if(totalPriceEl)totalPriceEl.textContent=money(totalPrice);if(buttonPrice)buttonPrice.textContent=money(totalPrice);
      const available=Boolean(variant&&variant.available);if(addButton){addButton.disabled=!available;addButton.setAttribute('aria-disabled',String(!available));}
    }

    widthButtons.forEach(button=>button.addEventListener('click',()=>{widthButtons.forEach(item=>item.classList.remove('active'));button.classList.add('active');rebuildLengthOptions(preferredLengthNumber);updateOrder();}));
    lengthSelect.addEventListener('change',()=>{preferredLengthNumber=numericMetres(lengthSelect.value)||preferredLengthNumber;updateOrder();});
    q(hero,'[data-m42-qty-minus]')?.addEventListener('click',()=>{quantity=Math.max(1,quantity-1);updateOrder();});
    q(hero,'[data-m42-qty-plus]')?.addEventListener('click',()=>{quantity=Math.min(99,quantity+1);updateOrder();});

        /*
      ADD TO CART

      Pet Flow 35 prepares the exact Shopify variant and quantity first.
      Rosyz then handles the actual submission using its native AjaxCart.
    */

    form.addEventListener(
      'submit',
      () => {
        const variant = findVariant();

        if (!variant || !variant.available) {
          return;
        }

        variantInput.value = String(variant.id);
        quantityInput.value = String(quantity);
      }
    );

    const attachRosyzAjaxCart = () => {
      if (
        form.dataset.pf35AjaxCartReady === 'true'
      ) {
        return true;
      }

      if (
        !window.jQuery ||
        typeof window.AjaxCart !== 'function'
      ) {
        return false;
      }

      try {
        new window.AjaxCart(
          window.jQuery(form)
        );

        form.dataset.pf35AjaxCartReady =
          'true';

        return true;
      } catch (error) {
        console.error(
          'Pet Flow 35 AjaxCart could not initialise.',
          error
        );

        return false;
      }
    };

    if (!attachRosyzAjaxCart()) {
      let ajaxCartAttempts = 0;

      const ajaxCartTimer =
        window.setInterval(() => {
          ajaxCartAttempts += 1;

          if (
            attachRosyzAjaxCart() ||
            ajaxCartAttempts >= 50
          ) {
            window.clearInterval(
              ajaxCartTimer
            );
          }
        }, 100);
    }

    rebuildLengthOptions(1);updateOrder();
  }

  const init=(root=document)=>{if(root.matches?.('[data-m42-hero]'))initHero(root.parentElement||document);else initHero(root);};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
